/**
 * @file Jquery ui draggable
 */
// Order of import is important
// organize-imports-ignore
import { $ } from '@@/bits/jquery'
import 'jquery-ui/ui/widgets/draggable'
// prettier-ignore
import '@@/vendor/jquery.ui.touch-punch'
export { $ }
